
<div id="wrapper" class="MainLogin">
  
  <div class="container-fluid">
    <div class="page-content-wrapper">
      <div class="col-lg-5 col-md-7 col-sm-9 col-xs-12 no-float">
        <div class="login-wrapper">
          <div class="login-details">
            <div class="logo-wrapper">
              <img style="width: 70%;" alt="{{logoAlert}}" src="{{logoSrc}}" />
            </div>
            <div class="credentials-wrapper">
              <div class="login-btn">
                <button type="button" class="btn btn-success secondary-btn" (click)="getUserDomainDetails()">
                  <span>sign in as employee</span>
                </button>
                <div class="col-lg-12 col-md-12 col-sm-12 no-padding or-separator">
                  <span class="or"></span>
                  <span>OR</span>
                  <span class="or"></span>
                </div>
                <button type="button" class="btn btn-success primary-btn" (click)="openContractorLoginWindow()">
                  <span>sign in as contractor</span>
                </button>
                <!-- <div class="col-lg-12 col-md-12 col-sm-12 no-padding or-separator">
                  <span class="or"></span>
                  <span class="or"></span>
                </div>
                <button type="button" class="btn btn-success" (click)="fixLoginIssue()">Fix login issue</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
